import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_LOCAL_USERS_REQUEST,
  FETCH_LOCAL_USERS_SUCCESS,
  FETCH_LOCAL_USERS_ERROR,
  EDIT_LOCAL_USERS_REQUEST,
  EDIT_LOCAL_USERS_SUCCESS,
  EDIT_LOCAL_USERS_ERROR,
  DELETE_LOCAL_USERS_REQUEST,
  DELETE_LOCAL_USERS_SUCCESS,
  DELETE_LOCAL_USERS_ERROR,
} from 'actionTypes'

export const fetch = (token, filters) => (dispatch) =>
  new Api(token, dispatch)
    .post(
      `${API_URL.FETCH_LOCAL_USERS}?page=${filters.page}&size=${filters.size}`,
      filters
    )
    .then(dispatch(showSpinner()))
    .then(dispatch(actionSet(FETCH_LOCAL_USERS_REQUEST)))
    .then((response) => {
      dispatch(getPages(response.data.pages))
      dispatch(actionSet(FETCH_LOCAL_USERS_SUCCESS, response.data.resultList))
    })
    .catch((error) => dispatch(actionSet(FETCH_LOCAL_USERS_ERROR, error)))
    .finally(() => dispatch(hideSpinner()))

export const save =
  (token, params, successCallback, errorCallback) => (dispatch) =>
    new Api(token, dispatch)
      .post(API_URL.SAVE_LOCAL_USERS, params)
      .then(dispatch(showSpinner()))
      .then(dispatch(actionSet(EDIT_LOCAL_USERS_REQUEST)))
      .then((response) => {
        dispatch(actionSet(EDIT_LOCAL_USERS_SUCCESS, response.data))

        if (successCallback) successCallback()
      })
      .catch((error) => {
        dispatch(actionSet(EDIT_LOCAL_USERS_ERROR, error))

        if (errorCallback)
          errorCallback(error && error.message ? error.message.dsMessage : null)
      })
      .finally(() => dispatch(hideSpinner()))

export const remove =
  (token, params, successCallback, errorCallback) => (dispatch) =>
    new Api(token, dispatch)
      .post(API_URL.DELETE_LOCAL_USERS, params)
      .then(dispatch(showSpinner()))
      .then(dispatch(actionSet(DELETE_LOCAL_USERS_REQUEST)))
      .then((response) => {
        dispatch(actionSet(DELETE_LOCAL_USERS_SUCCESS, response.data))

        if (successCallback) successCallback()
      })
      .catch((error) => {
        dispatch(actionSet(DELETE_LOCAL_USERS_ERROR, error))

        if (errorCallback) errorCallback()
      })
      .finally(() => dispatch(hideSpinner()))
